import axios from "axios";
import { API_URL } from "../index";
import { normalizeServiceId, pickOfferUserId, isOfferActive, resolveRequestStatusAfterOfferReject } from "../servisOrtak";

// FE-84: Services.js'ten taşındı (12 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisTeklif = {

  CreateOffer(token, userID, requestID, offerExpireDate, offer, merchantID, warehouseID) {
    const offerSource = offer && typeof offer === "object" ? offer : {};
    const data = {
      userID: userID,
      requestID: requestID,
      offer: offer,
      offerExpiredDate: offerExpireDate,
      merchantID: ""
    };

    // Sadece değerler varsa ekle (evden eve ve şehirlerarası için gönderilmez)
    if (merchantID) data.merchantID = merchantID;
    if (warehouseID) data.warehouseID = warehouseID;
    if (offerSource.isWarehouseExit !== undefined) data.isWarehouseExit = offerSource.isWarehouseExit;
    if (offerSource.sourceStorageOperationID) data.sourceStorageOperationID = offerSource.sourceStorageOperationID;
    if (offerSource.sourceRoomNo) data.sourceRoomNo = offerSource.sourceRoomNo;

    return axios({
      method: "post",
      url: `${API_URL}flow/create-offer`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data
    });
  },

  GetOffers(token, requestID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-offers`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        requestID: requestID
      }
    });
  },

  GetAllOffers(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-offers`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  // cancelDescription: reddederken yazılan açıklama (offers.cancel_description). "Diğer"de zorunlu.
  CancelOffer(token, offerID, cancelReason, cancelDescription = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/cancel-offer`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        offerID,
        cancelReason,
        cancelDescription
      }
    });
  },

  ConfirmOffer(token, offerID, payload = {}) {
    const data = { offerID };
    const source = payload && typeof payload === "object" ? payload : {};
    const resolvedOffer =
      source?.offer && typeof source.offer === "object"
        ? source.offer
        : Object.keys(source).length > 0
          ? source
          : null;
    const resolvedOperationTime = String(
      source?.operationStartTime ?? source?.operationTime ?? source?.appointmentTime ?? ""
    ).trim();

    if (source?.corporationID) data.corporationID = source.corporationID;
    if (source?.address) data.address = source.address;
    if (source?.fromAddress) data.fromAddress = source.fromAddress;
    if (source?.toAddress) data.toAddress = source.toAddress;
    if (source?.operationDate) data.operationDate = source.operationDate;
    if (resolvedOperationTime) {
      data.operationTime = resolvedOperationTime;
      data.operationStartTime = resolvedOperationTime;
      data.appointmentTime = resolvedOperationTime;
    }
    if (source?.authorizedNameLastname) data.authorizedNameLastname = source.authorizedNameLastname;
    if (source?.authorizedPhone) data.authorizedPhone = source.authorizedPhone;
    if (source?.additionalNote !== undefined) data.additionalNote = source.additionalNote;
    if (source?.isWarehouseExit !== undefined) data.isWarehouseExit = source.isWarehouseExit;
    if (source?.sourceStorageOperationID) data.sourceStorageOperationID = source.sourceStorageOperationID;
    if (source?.sourceRoomNo) data.sourceRoomNo = source.sourceRoomNo;
    if (resolvedOffer) data.offer = resolvedOffer;

    return axios({
      method: "post",
      url: `${API_URL}flow/confirm-offer`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data
    });
  },

  CreateOperationFromOffer(token, payload = {}) {
    const source = payload && typeof payload === "object" ? payload : {};
    const data = {
      offerID: source.offerID,
      operationDate: source.operationDate || "",
      operationTime: source.operationTime || "",
      fromAddress: source.fromAddress || "",
      toAddress: source.toAddress || "",
      authorizedNameLastname: source.authorizedNameLastname || "",
      authorizedPhone: source.authorizedPhone || "",
      additionalNote: source.additionalNote || "",
      corporationID: source.corporationID || ""
    };
    if (source.isWarehouseExit !== undefined) data.isWarehouseExit = source.isWarehouseExit;
    if (source.sourceStorageOperationID) data.sourceStorageOperationID = source.sourceStorageOperationID;
    if (source.sourceRoomNo) data.sourceRoomNo = source.sourceRoomNo;

    return axios({
      method: "post",
      url: `${API_URL}flow/create-operation-from-offer`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data
    });
  },

  UpdateOffer(
    token,
    {
      offerID,
      offer,
      offerExpiredDate,
      merchantID,
      warehouseID,
      cancelReason
    } = {}
  ) {
    const data = {};

    if (offerID !== undefined && offerID !== null && String(offerID).trim() !== "") data.offerID = offerID;
    if (offer && typeof offer === "object") {
      data.offer = offer;
      if (offer.isWarehouseExit !== undefined) data.isWarehouseExit = offer.isWarehouseExit;
      if (offer.sourceStorageOperationID) data.sourceStorageOperationID = offer.sourceStorageOperationID;
      if (offer.sourceRoomNo) data.sourceRoomNo = offer.sourceRoomNo;
    }
    if (offerExpiredDate !== undefined && offerExpiredDate !== null && String(offerExpiredDate).trim() !== "") {
      data.offerExpiredDate = offerExpiredDate;
    }
    if (merchantID !== undefined && merchantID !== null && String(merchantID).trim() !== "") {
      data.merchantID = merchantID;
    }
    if (warehouseID !== undefined && warehouseID !== null && String(warehouseID).trim() !== "") {
      data.warehouseID = warehouseID;
    }
    if (cancelReason !== undefined && cancelReason !== null && String(cancelReason).trim() !== "") {
      data.cancelReason = cancelReason;
    }

    return axios({
      method: "post",
      url: `${API_URL}flow/update-offer`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data
    });
  },

  MarkOffersAsRequestUpdated(token, requestID) {
    if (!requestID) {
      return Promise.resolve({ status: false, totalOfferCount: 0, updatedOfferCount: 0 });
    }

    return this.GetOffers(token, requestID).then(async (res) => {
      if (!res?.data?.status) {
        return { status: false, totalOfferCount: 0, updatedOfferCount: 0 };
      }

      const allOffers = Array.isArray(res.data.result) ? res.data.result : [];
      // SİLİNMİŞ / İPTAL / REDDEDİLMİŞ teklifler (status 0, 2, -1) hariç tutulur: hepsi
      // ayrımsız 6'ya ("Talep Güncellendi") çekildiğinde bu kayıtlar listede yeniden
      // aktif teklif olarak diriliyordu.
      const offers = allOffers.filter(isOfferActive);
      const results = await Promise.allSettled(
        offers.map((offer) => this.UpdateOfferStatus(token, offer.offerID, 6))
      );
      const updatedOfferCount = results.filter(
        (r) => r.status === "fulfilled" && r.value?.data?.status
      ).length;

      return { status: true, totalOfferCount: offers.length, updatedOfferCount, results };
    });
  },

  async RestoreOfferRelatedStatusesIfLastOfferRemoved(token, options = {}) {
    const requestID = normalizeServiceId(options?.requestID);
    const userID = normalizeServiceId(options?.userID);
    const requestStatus = String(options?.requestStatus ?? "3").trim();
    const currentRequestStatus = normalizeServiceId(options?.currentRequestStatus);
    const userStatus = String(options?.userStatus ?? "0").trim();
    // Reddetme akışı Services'e `rejectReason` geçer → talep statüsü reddetme kurallarıyla
    // türetilir (bkz. resolveRequestStatusAfterOfferReject). Silme akışında boştur → eski
    // (resolveRequestStatusAfterOfferRemoval) davranışı korunur.
    const rejectReason = String(options?.rejectReason ?? "").trim();

    const baseResult = {
      status: false,
      requestStatusUpdated: false,
      userStatusUpdated: false,
      totalOfferCount: 0,
      activeOfferCount: 0,
      totalUserOfferCount: 0,
      activeUserOfferCount: 0,
    };

    if (!requestID && !userID) {
      return baseResult;
    }

    let allOffers = null;

    try {
      const allOffersRes = await this.GetAllOffers(token);
      if (allOffersRes?.data?.status && Array.isArray(allOffersRes?.data?.result)) {
        allOffers = allOffersRes.data.result;
      }
    } catch (_) {
      allOffers = null;
    }

    if (!allOffers && requestID) {
      try {
        const requestOffersRes = await this.GetOffers(token, requestID);
        if (requestOffersRes?.data?.status && Array.isArray(requestOffersRes?.data?.result)) {
          const requestOffers = requestOffersRes.data.result;
          const activeRequestOffers = requestOffers.filter(isOfferActive);
          // Reddetme VE silme aynı türetmeden geçer (sebep tekliflerden alınır; yoksa fallback).
          const nextRequestStatus = resolveRequestStatusAfterOfferReject(
            requestOffers,
            rejectReason,
            requestStatus,
            currentRequestStatus
          );

          if (!nextRequestStatus) {
            return {
              ...baseResult,
              status: true,
              totalOfferCount: requestOffers.length,
              activeOfferCount: activeRequestOffers.length,
            };
          }

          const updateRes = await this.UpdateRequestStatus(token, requestID, nextRequestStatus);
          return {
            ...baseResult,
            status: Boolean(updateRes?.data?.status),
            requestStatusUpdated: Boolean(updateRes?.data?.status),
            totalOfferCount: requestOffers.length,
            activeOfferCount: 0,
            requestUpdateResponse: updateRes,
          };
        }
      } catch (_) {
        return baseResult;
      }
    }

    if (!allOffers) {
      return baseResult;
    }

    const requestOffers = requestID
      ? allOffers.filter((offer) => normalizeServiceId(offer?.requestID) === requestID)
      : [];
    const activeRequestOffers = requestOffers.filter(isOfferActive);

    const userOffers = userID
      ? allOffers.filter((offer) => pickOfferUserId(offer) === userID)
      : [];
    const activeUserOffers = userOffers.filter(isOfferActive);

    let requestUpdateResponse = null;
    let requestStatusUpdated = false;
    const nextRequestStatus = requestID
      ? resolveRequestStatusAfterOfferReject(requestOffers, rejectReason, requestStatus, currentRequestStatus)
      : null;
    if (requestID && nextRequestStatus) {
      requestUpdateResponse = await this.UpdateRequestStatus(token, requestID, nextRequestStatus);
      requestStatusUpdated = Boolean(requestUpdateResponse?.data?.status);
    }

    let userUpdateResponse = null;
    let userStatusUpdated = false;
    if (userID && activeUserOffers.length === 0) {
      userUpdateResponse = await this.UpdateUserStatus(token, userID, userStatus, {
        protectActiveCustomer: true,
      });
      userStatusUpdated = Boolean(userUpdateResponse?.data?.status);
    }

    const requestHandled = !requestID || !nextRequestStatus || requestStatusUpdated;
    const userHandled = !userID || activeUserOffers.length > 0 || userStatusUpdated;

    return {
      ...baseResult,
      status: requestHandled && userHandled,
      requestStatusUpdated,
      userStatusUpdated,
      totalOfferCount: requestOffers.length,
      activeOfferCount: activeRequestOffers.length,
      totalUserOfferCount: userOffers.length,
      activeUserOfferCount: activeUserOffers.length,
      requestUpdateResponse,
      userUpdateResponse,
    };
  },

  RestoreRequestStatusIfLastOfferRemoved(token, requestID, status = 3) {
    return this.RestoreOfferRelatedStatusesIfLastOfferRemoved(token, {
      requestID,
      requestStatus: status,
    });
  },

  UpdateOfferStatus(token, offerID, status) {
    const normalizedStatus =
      status === null || status === undefined || status === ""
        ? status
        : Number.isNaN(Number(status))
          ? status
          : Number(status);

    const data = {
      offerID,
      status: normalizedStatus
    };
    return axios({
      method: "post",
      url: `${API_URL}flow/offer-change-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data
    });
  },
  GetOfferById(token, offerID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-offers`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { offerID },
    });
  },
};

export default servisTeklif;
